import * as PropTypes from 'prop-types';
import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import { CianInfo } from '../../../common/components/CianInfo';
import { IMoreButtonTracking } from '../../../common/components/menu/more/tracking';
import { UserInfoBrandPopup } from '../../../common/components/UserInfoBrandPopup';
import { IOfferHelper } from '../../../presenter';
import { IOffer } from '../../../types/offer';
import { IButtonsTracking } from '../buttons/tracking';
import * as styles from './AgentBrand.css';
import { ShowMoreOffers } from '../../../components/showMoreOffers/';
import { AgentBrandMainInfo } from './mainInfo/AgentBrandMainInfo';
import { PhoneButton } from './phoneButton/PhoneButton';
import { ContactStatus } from '../../../common/components/ContactStatus';
import { getNewbuildingLabel } from '../../../utils/getNewbuildingLabel';
import { INewbuildingLabel } from '../../../types/newbuildingLabel';

export interface IAgentBrandProps {
  position: number;
  isSimilar: boolean;
  /** Отрисован ли блок брендирования в карточке топ-3 (для нее иная верстка) */
  isUsedOnTop3Card?: boolean;
}

export interface IAgentBrandContext {
  api: {
    tracking: IButtonsTracking & IMoreButtonTracking;
  };
  offer: IOffer;
  offerHelper: IOfferHelper;
  newbuildingLabel: INewbuildingLabel | null;
  onlineShowEnabled: boolean;
}

export class AgentBrand extends React.Component<IAgentBrandProps> {
  public context: IAgentBrandContext;

  public static contextTypes = {
    api: PropTypes.object,
    offer: PropTypes.object,
    offerHelper: PropTypes.object,
    countrysideOffersBuilderBadge: PropTypes.bool,
    newbuildingLabel: PropTypes.object,
    onlineShowEnabled: PropTypes.bool,
  };

  public render() {
    const { offer } = this.context;
    const { isUsedOnTop3Card } = this.props;
    const isPhoneHidden = !!offer.kp && !offer.kp.displayBuilderPhone;
    const phones = this.context.offerHelper.presenters.getPhones();
    const isLeadFactory = this.context.offerHelper.isLeadFactory();
    const contactStatus = this.renderContactStatus();

    return (
      <div>
        <div
          { ...mergeStyles([
            styles['agent'],
            !isUsedOnTop3Card && styles['agent--premium'],
          ]) }
          onClick={ this.handleClickWithStopPropagation }
        >
          {isLeadFactory
            ? <CianInfo />
            : <UserInfoBrandPopup
                isReverseOrder
                content={ <AgentBrandMainInfo isUsedOnTop3Card={ isUsedOnTop3Card }/> }
                userInfoStyle={ styles['user-info'] }
                userInfoStyleAction={ styles['user-info-action'] }
              />
          }

          { offer.isTop3 && !isLeadFactory && <ShowMoreOffers/> }
          {contactStatus}
          {
            !isPhoneHidden && phones &&
            <PhoneButton
              offer={ offer }
              onPhoneOpened={ this.handlePhoneOpen }
              phones={ phones }
              isUsedOnTop3Card={ isUsedOnTop3Card }
              dynamicCalltrackingPlaceType="sidePanel"
              hasContactLabel={ !!contactStatus }
            />
          }
        </div>
      </div>
    );
  }

  private renderContactStatus() {
    const { offer, onlineShowEnabled } = this.context;
    const newbuildingId = Number(offer.newbuilding?.id);
    const canShowOnline = onlineShowEnabled && Boolean(offer.user && offer.user.canShowOnline);
    const isFromDeveloper = this.context.offerHelper.isFromDeveloper();
    const isLeadFactory = this.context.offerHelper.isLeadFactory();

    const builderStatusTexts =
      newbuildingId
        ? getNewbuildingLabel(this.context, isFromDeveloper, isLeadFactory, newbuildingId)
        : '';

    if (!builderStatusTexts && !canShowOnline) {
      return null;
    }

    return (
      <div className={styles['contact-label']}>
        {builderStatusTexts ? (
          <ContactStatus
            {...builderStatusTexts}
          />
        ) : (
          <ContactStatus
            labelText="Онлайн-показ"
            tooltipTitle="Выбирайте не выходя из дома"
            tooltipText="Вам могут провести онлайн-показ объекта при помощи видеозвонка в WhatsApp, Viber, FaceTime или другой программы"
          />
        )}
      </div>
    );
  }

  private handlePhoneOpen = () => {
    const { tracking } = this.context.api;

    if (tracking && tracking.trackPhoneOpened) {
      tracking.trackPhoneOpened(true);
    }
  }

  private handleClickWithStopPropagation = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  }
}
